// extracted by mini-css-extract-plugin
export default {"topicText":"index_topicText_-kTHS"};